var $ = jQuery;
import { tooltipAnnotations } from './tooltip-annotation.js';
import _ from '../libs/lodash.min.js';

class Annotation {

  constructor($element, label) {
    this.$element = $element;
    this.label = label;

    this.data = this.$element.attr('data-annotation');
    let regex = /(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.#?&//=]*))(?!.)/;
    // let regex = /(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*))/;
    this.data = this.data.replace(regex, '<a href="$1">$1</a>');
    // wait until tooltip code has run
    this.$bubble = this.$element.find('.tooltip__bubble');
    this.initialize();
  }

  initialize() {
    this.format();
    this.enable();
  }

  format() {
    let $label = this.$element.find('>:first-child');
    $label.addClass('annotation__label');
    $label.html(this.label);
    $label.prepend(`<a name="_ftn${this.label}" id="_ftnref${this.label}"></a>`);
    this.$bubble.find('.tooltip__paragraph').html(this.data);
  }

  enable() {
    this.$element.on('mouseover', () => {
      this.handleMouseOver();
    });

    this.$element.on('mouseout', () => {
      this.handleMouseOut();
    });
  }

  handleMouseOver() {
    this.$bubble.addClass('_active');
  }

  handleMouseOut() {
    this.$bubble.removeClass('_active');
  }

}

class References {

  constructor($context) {
    if($($context).find('.article__references').length > 0) {
      return false;
    }

    this.$context =  $context;
    tooltipAnnotations(this.$context);
    this.createAnnotations();
    this.createList();
  }

  createAnnotations() {
    let $elements = this.$context.find('.annotation__highlight');
    this.$articleBody = this.$context;
    this.annotations = [];
    for(let i = 0; i < $elements.length; i++) {
      let $e = $($elements.get(i));
      let label = i + 1;
      this.annotations.push(new Annotation($e, label));
    }
  }

  createList() {
    this.$references = this.findReferences();
    this.$wrapper = this.$references.find('.accordion-target__wrapper');
    this.$wrapper.empty();

    _.forEach(this.annotations, (annotation) => {
      this.createReference(annotation);
    });
  }

  findReferences() {
    let $references = $(this.$context).find('.article__references');

    if($references.length === 0) {

      this.$articleBody.after(`
        <section class="article__references">
          <button class="article__references-toggle accordion-trigger">
            <span>Show</span> References <i class="heritage-icon-expand" aria-hidden="true"></i>
          </button>
          <div class="article__references-wrapper accordion-target">
              <div class="accordion-target__wrapper"></div>
          </div>
        </div>
      `);

      return this.$articleBody.next();
    }

    //removed because it was coming back correct
    // else {
    //   //this.$wrapper.empty();
    //   return $references;
    // }
  }

  createReference(annotation) {
    let {label, data} = annotation;
    this.$wrapper.append(`
      <div class="article__references-reference">
          <a name="_ftn${label}" href="#_ftnref${label}" class="reference-anchor">[${label}]</a>
          <div class="content">
              ${data}
          </div>
      </div>
    `);
  }

}

function init() {
  // doesn't run on legacy
  $(document).ready(function() {
    $('.article__body-copy').each(function() {
      if($(this).find('.annotation__highlight').length > 0) {
        new References($(this));
      }
    });
  });

  $(document).on('newSectionAdded', function(e, context) {
    if($(context).find('.annotation__highlight').length > 0) {
      new References($(context).find('.article__body-copy'));
    }
  });

  // TODO: Move these into functions for legacy content

  $('.article__references').on('click', '.article__references-wrapper a[href^="#_"]', function(e) {
    e.preventDefault();
    var target = this.hash;
    var parent = $(this).closest('.article__references');
    var articleAnchors = parent.prev('.article__body-copy');
    var $target = articleAnchors.find(target);

    $('html, body').stop().animate({
      'scrollTop': $target.offset().top - 150
    }, 900, 'swing', function () {
      window.location.hash = target;
    });
  });

  $('.article__body-copy').on('click', 'a[href^="#_"]', function(e) {
    e.preventDefault();
    var target = this.hash;
    var parent = $(e.delegateTarget);
    var anchor =  $(this).attr('name');
    var reference = $(parent).next('.article__references');
    var link = $(reference).find('a[href="#'+anchor+'"]');

    if(!$(reference).find('.article__references-toggle').hasClass('_active')) {
      $(reference).find('.article__references-toggle').trigger('click');
    }
    $('html, body').stop().animate({
      'scrollTop': link.offset().top - 150
    }, 900, 'swing', function () {
      window.location.hash = target;
    });


  });

}

export { init as init };
